/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 * @author Yakov.Gushchin
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';
import { FlexStyled } from '../../Block/Flexbox';

const ThStyled = styled.div`
    vertical-align: middle;
    white-space: nowrap;
    text-align: center;
    ${fonts.textSmallBold};
`;

const TrStyled = styled(FlexStyled).attrs({
    className: 'range-date-picker__calendar-head-tr mb-2',
})`
    justify-content: space-between;
`;

export {
    ThStyled,
    TrStyled,
};
